import React from 'react'
import Landing from '../routes/landings/Office'

const Office = () => {
  return <Landing />
}

export default Office
